import React from 'react'
import PropTypes from 'prop-types'
import { Autocomplete } from '@material-ui/lab'
import SimpleInput from 'app/componentV4/Input/SimpleInput'
import { makeStyles } from '@material-ui/core'
import { useIntl } from 'react-intl'

const useStyles = makeStyles((theme) => ({
  endAdornment: {
    width: '100%',
    position: 'absolute',
    right: 10,
    top: '50%',
    transform: 'translateY(-50%)',
  },
}))

const RegionSelector = ({
  value,
  onChange,
  placeholder,
  className,
  regions,
}) => {
  const classes = useStyles()

  const { formatMessage } = useIntl()

  return (
    <Autocomplete
      options={regions}
      getOptionLabel={(option) => option.name}
      value={regions.find((g) => g.id === value) || null}
      className={className}
      noOptionsText={formatMessage({
        id: 'crm.form.receiveMethods.option.empty',
      })}
      onChange={(event, newValue) => {
        if (onChange) {
          onChange(newValue ? newValue.id : null)
        }
      }}
      renderInput={(params) => (
        <div ref={params.InputProps.ref} className="w-full">
          <SimpleInput
            id="nationality"
            placeholder={placeholder}
            endAdornment={
              <div className={classes.endAdornment}>
                {params.InputProps.endAdornment}
              </div>
            }
            size="medium"
            fullWidth
            {...params}
          />
        </div>
      )}
    />
  )
}

RegionSelector.propTypes = {
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onChange: PropTypes.func.isRequired,
  placeholder: PropTypes.string,
  className: PropTypes.string,
}

export default RegionSelector
